import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Loader2 } from "lucide-react";

export const RequireAdmin = ({ children }) => {
  const { checking, isAuthed } = useAuth();
  if (checking) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center text-[var(--bw-secondary)]">
        <Loader2 className="w-5 h-5 animate-spin" />
      </div>
    );
  }
  if (!isAuthed) return <Navigate to="/admin/login" replace />;
  return children;
};

export default RequireAdmin;
